import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';
import Toggle from '../Toggle';
import FormField from './FormField';
import FormGroup from './FormGroup';
import DatePicker from '../datePicker/DatePicker';

const dateInputFormat = 'YYYY-MM-DD';

export default class DateInput extends FormField {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleInputChange(e) {
    const value = e.target.value;
    const date = moment(value, dateInputFormat);
    this.handleDateChange(value && date.isValid() ? date : null);
  }

  handleDateChange(date) {
    this.props.onChange(date);
  }

  isValid(date) {
    return moment(date).isValid() && (!this.props.minDate || this.props.minDate.isBefore(date));
  }

  render() {
    const { error, checked } = this.state;
    const value = this.props.value;
    const inputProps = _.omit(this.props, 'minDate');
    if (this.props.vacancyMode) {
      return (
        <FormGroup {...this.props}>
          <DatePicker
            {...this.props}
            className={classNames({ error, checked })}
            onChange={this.handleDateChange}
            onBlur={this.props.onBlur}
          />
        </FormGroup>
      );
    }
    return (
      <FormGroup {...this.props}>
        <Toggle show="xs sm">
          <input
            {...inputProps}
            className={classNames('form-group-input input-date', { error, checked })}
            type="date"
            onChange={this.handleInputChange}
            onBlur={this.props.onBlur}
            min={moment(this.props.minDate).format(dateInputFormat)}
            value={value ? moment(value).format(dateInputFormat) : ''}
          />
        </Toggle>
        <Toggle show="md lg xl">
          <DatePicker
            {...this.props}
            className={classNames({ error, checked })}
            onChange={this.handleDateChange}
            onBlur={this.props.onBlur}
          />
        </Toggle>
      </FormGroup>
    );
  }
}

DateInput.propTypes = {
  ...FormField.propTypes,
  value: PropTypes.instanceOf(moment),
  vacancyMode: PropTypes.bool,
};

DateInput.defaultProps = {
  minDate: moment(),
  vacancyMode: false,
};
